import { useEffect, useState } from "react";

// True from the `sm` breakpoint up. Used to skip heavy assets (video) on phones.
export const useWide = (query = "(min-width: 640px)") => {
  const [wide, setWide] = useState(() => (typeof window !== "undefined" ? window.matchMedia(query).matches : false));
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = (e) => setWide(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return wide;
};
